import React, { useState } from 'react';

export default function SaveBuildModal({ onClose, onSave, productDetails }) {
  const [saveBuildName, setSaveBuildName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    setSaveBuildName(e.target.value);
    if (errorMessage) {
      setErrorMessage('');
    }
  };

  const handleSave = () => {
    if (!productDetails || !productDetails.Tractor || !productDetails.Tractor.Material || productDetails.Tractor.Material.length <= 0) {
      setErrorMessage('Please select and get started on your custom build out your Dream Vehicle before trying to Save.');
      return;
    }

    if (saveBuildName.trim().length === 0) {
      setErrorMessage('Please enter a name for your build.');
      return;
    }

    onSave(saveBuildName);
  };

  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">Save This Build?</h2>
      </div>
      <div className="modal-body saveBuildModalBody">
        <p>If you leave you will lose your current configuration. Name and save this build to add it to your account.</p>
        <input 
          type="text" 
          id="txtSaveBuildName" 
          name="txtSaveBuildName" 
          value={saveBuildName}
          onBlur={handleInputChange} 
          onChange={handleInputChange} 
          maxLength="50" 
          required={true}
          placeholder="Enter build name..."
        />
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <button 
          id="save-this-build-button" 
          className="orange-button button saveBuildButton" 
          onClick={handleSave}
        >
          <span>Save</span>
        </button>
      </div>
    </>
  );
}